import { ThemeColor } from 'components/settings/components/sections/dixaMessenger/views/appearance/types';

export const presetBackgrounds: ThemeColor[] = [
  {
    id: 'purple',
    title: 'Purple',
    background: '#5c2ade',
    presentationColor:
      'linear-gradient(159.07deg, #5644D8 13.79%, #392AA7 86.13%)',
  },
  {
    id: 'emerald',
    title: 'Emerald',
    background: '#1e7282',
    presentationColor:
      'linear-gradient(159.24deg, #2A8491 13.71%, #126476 86.22%)',
  },
  {
    id: 'blue',
    title: 'Blue',
    background: '#2c69dc',
    presentationColor:
      'linear-gradient(186.25deg, #2C6CCC 4.95%, #1A56B0 95.08%)',
  },
  {
    id: 'midnight',
    title: 'Midnight',
    background: '#1c2741',
    presentationColor:
      'linear-gradient(159.07deg, #003D66 13.79%, #132244 86.13%)',
  },
  {
    id: 'grey',
    title: 'Grey',
    background: '#8b8c8d',
    presentationColor:
      'linear-gradient(186.25deg, #9D9D9D 4.95%, #808182 95.08%)',
  },
];
